import { Component, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { ApplicationItem } from "../../model/ApplicationItem";
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-application-typeahead',
  providers: [ConfigurationService],
  outputs: ['applicationChange'],
  template: `
      <mat-form-field style="width: 100%;">
        <input type="text" matInput [formControl]="applicationControl"
            [matAutocomplete]="auto" [(ngModel)]="applicationSelected" style="padding:6px 12px;">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="change($event.option.value)">
              <mat-option style="background:white;" *ngFor="let application of filtered | async" [value]="application">
                  {{application.Name}}
              </mat-option>
          </mat-autocomplete>
    </mat-form-field>
    `
})

export class ApplicationTypeaheadComponent implements OnChanges {
  applicationSelected: ApplicationItem;
  applicationChange = new EventEmitter<ApplicationItem>();

  applicationControl = new FormControl();
  applications: ApplicationItem[] = [];
  filtered: Observable<ApplicationItem[]>;

  constructor(private applicationService: ConfigurationService) {
    this.getapplications().subscribe(data => {
        this.applications = data;

        this.filtered = this.applicationControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this.filter(value))
          );
      });
  }

  displayFn(application?: ApplicationItem): string | undefined {
    return application ? application.Name : undefined;
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    for (let propName in changes) {
      if (propName === 'applicationSelected') {
        this.load();
      }
    }
  }

  change(application: ApplicationItem) {
    this.applicationChange.emit(application);
  }

  private getapplications(): Observable<ApplicationItem[]> {
    if (this.applications.length > 0) {
        return Observable.of(this.applications);
    }
    else {
      return new Observable<ApplicationItem[]>(observer => {
        this.applicationService.GetApplications()
          .subscribe(data => {
            this.applications = data;
            observer.next(this.applications);
            observer.complete();
          });
      });
    }
  };

  private load() {
    if (Boolean(this.applicationSelected)) {
      if (!Boolean(this.applicationSelected.Name) && Boolean(this.applicationSelected.Id)) {
        var applicationId = this.applicationSelected.Id;
        this.getapplications().subscribe(data => {
          var application = data.find(function (a) {
            return a.Id === applicationId;
          });
          if (Boolean(application)) {
            this.applicationSelected.Name = application.Name;
            this.change(this.applicationSelected);
          }
        });
      }
      else if (Boolean(this.applicationSelected.Name) && !Boolean(this.applicationSelected.Id)) {
        var applicationName = this.applicationSelected.Name;
        this.getapplications().subscribe(data => {
          var application = this.applications.find(function (a) {
            return a.Name === applicationName;
          });
          if (Boolean(application)) {
            this.applicationSelected.Id = application.Id;
            this.change(this.applicationSelected);
          }
        });
      }
    }
  }

  private filter(value: any): ApplicationItem[] {
    this.change(null);
    if (value) {
      if (typeof value === "string") {
        const filterValue = value.toLowerCase();
        return this.applications.filter(application => application.Name.toLowerCase().includes(filterValue));
      }
    }
    else
      return this.applications;
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/application.typeahead.component.ts